import React, { Component } from "react";

import Header from '../LandingPage/Header'
import Navbar from '../LandingPage/Navbar'
import Footer from '../LandingPage/Footer'
import AboutPostHeader from './AboutPostHeader'
import PreFooter from './PreFooter'

const ContactUS = () => {
    const contact = {
        head: "Contact Me",
        para: "Feel Free to contact Me for any questions and queries!",
      };
  return (
    <div>
     <Header />
     <Navbar />
     <AboutPostHeader obj={contact} />
      <div className="sec">
        <div className="container mt-5">
          <div className="row">
            <div className="col-12">
              <i class="fas fa-3x text-primary fa-id-card-alt"></i>
              <h2 className="mt-3">Contact Information</h2>
              <p className="font-weight-bold">
               I am always here to answer any of your questions and
                queries.Either drop me an mail / call or through social media and i
                will get back to you.
              </p>
              <p>
                {" "}
                <a href="#" data-toggle="tooltip" data-placement="top" title="email">  <i class="fas fa-2x fa-phone"></i></a>
               <label className="ml-3">+92-3170762829</label>
              </p>
              <p>
                {" "}
                <a href="#" data-toggle="tooltip" data-placement="top" title="email">  <img src="https://cdn.iconscout.com/icon/premium/png-256-thumb/email-1509734-1277271.png" alt="Girl in a jacket" className="image " style={{width:"30px"}} /></a>
               <label className="ml-3">2016cs438@student.uet.edu.pk</label>
              </p>
              <p>
                {" "}
                <a href="https://www.facebook.com/muhammadhassan.naseer.79" data-toggle="tooltip" data-placement="top" title="facebook">  <img src="https://cdn.iconscout.com/icon/free/png-256/facebook-logo-2019-1597680-1350125.png" alt="Girl in a jacket" className="image " style={{width:"30px"}} /></a>
                <label className="ml-3">muhammadhassan.naseer.79</label>
               
              </p>
              <p>
                {" "}
                <a href="https://www.linkedin.com/in/muhammad-hassan-naseer-ahmed-55533b1b6/" data-toggle="tooltip" data-placement="top" title="linked-In"><img src="https://upload.wikimedia.org/wikipedia/commons/e/e9/Linkedin_icon.svg" alt="Girl in a jacket" className="image "  style={{width:"30px"}}/></a>
                <label className="ml-3">in/muhammad-hassan-naseer-ahmed-55533b1b6/</label>

              </p>
              <p>
              <a href="https://twitter.com/Muhamma95552474" data-toggle="tooltip" data-placement="top" title="twitter"><img src="https://assets-global.website-files.com/5e39e095596498a8b9624af1/5e5dcda1afa1fe451f0e5ed2_5b45dcf979eda4c0ad71abe7_Twitter.png" alt="Girl in a jacket" className="image " style={{width:"30px"}}/></a>  
              <label className="ml-3">@Muhamma95552474
</label>

              </p>
            
            </div>
      
          </div>
        </div>
        <PreFooter />
        <Footer />
      </div>
    </div>
  );
};

export default ContactUS;
